import { Logger } from '@feature-hub/core';
import { useFeatureAppConfig } from './use-feature-app-config';
import { useFeatureServices } from './use-feature-services';

export function useLogger(): Logger {
  const { ['s2:logger']: logger = console } = useFeatureServices();
  const { useLoggerFeatureService } = useFeatureAppConfig();
  return useLoggerFeatureService ? logger : console;
}
